import { getAppVersion } from '@/utils/appVersion/getAppVersion';
import { getClientTimeZone } from '@/utils/tracking/getTimeZone';

import { type DeviceType, getDeviceType } from './getDeviceType';

export interface StaticAppInfo {
    appVersion: string;
    buildNum?: string;
    clientTimezone: string;
    deviceModelName: string;
    deviceModelNumber: string;
    deviceManufacturer: string;
    deviceChipset: string;
    deviceFirmware: string;
    deviceType: DeviceType;
    carrierName: string;
    postalCode: string;
    constraints: Array<string> | [];
}

export const getStaticAppInfo = (): StaticAppInfo => ({
    appVersion: getAppVersion(),
    buildNum: process.env.NEXT_PUBLIC_BUILD_NUMBER,
    clientTimezone: getClientTimeZone(),
    deviceType: getDeviceType(),
    deviceModelName: 'web',
    deviceModelNumber: '',
    deviceManufacturer: '',
    deviceChipset: '',
    deviceFirmware: '',
    carrierName: '',
    postalCode: '',
    constraints: [],
});
